import DarkModeToggle from "./DarkModeToggle";
import { useState, useEffect } from "react";

const Navbar = ({
  isDarkMode,
  toggleDarkMode,
  onSectionClick,
  scrollToChat,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleNavClick = (section) => {
    scrollToChat();
    setTimeout(() => {
      onSectionClick(section);
      setIsMobileMenuOpen(false);
    }, 500);
  };

  const toggleMobileMenu = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      if (!isMobileMenuOpen) {
        setIsMobileMenuOpen(true);
        setTimeout(() => setIsAnimating(false), 200);
      } else {
        const menu = document.querySelector('.mobile-menu');
        menu.classList.add('mobile-menu-exit');
        menu.classList.remove('mobile-menu-enter');
        
        setTimeout(() => {
          setIsMobileMenuOpen(false);
          setIsAnimating(false);
          menu.classList.remove('mobile-menu-exit');
        }, 200);
      }
    }
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.mobile-menu-button')) {
        toggleMobileMenu();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobileMenuOpen]);

  return (
    <nav className="py-6 w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo/empty left section for balance */}
          <div className="w-32">
            {/* Empty for layout balance */}
          </div>
          
          {/* Centered navigation links - hidden on mobile */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleNavClick("about")}
              className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-full bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
            >
              About
            </button>
            <button
              onClick={() => handleNavClick("investments")}
              className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-full bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
            >
              Investments
            </button>
            <button
              onClick={() => handleNavClick("projects")}
              className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-full bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
            >
              Projects
            </button>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className={`mobile-menu-button text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500 dark:focus:ring-gray-400 ${isMobileMenuOpen ? 'open' : ''}`}
            >
              <svg
                className="h-6 w-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
          
          {/* Right floating section */}
          <div className="flex items-center space-x-4 w-32 justify-end">
            <DarkModeToggle
              isDarkMode={isDarkMode}
              toggleDarkMode={toggleDarkMode}
            />
          </div>
        </div>

        {/* Mobile menu */}
        <div 
          className={`mobile-menu md:hidden mt-4 space-y-2 ${isMobileMenuOpen ? 'mobile-menu-enter' : ''}`}
          style={{ display: isMobileMenuOpen ? 'block' : 'none' }}
        >
          <button
            onClick={() => handleNavClick("about")}
            className="w-full text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
          >
            About
          </button>
          <button
            onClick={() => handleNavClick("investments")}
            className="w-full text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
          >
            Investments
          </button>
          <button
            onClick={() => handleNavClick("projects")}
            className="w-full text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 text-sm font-medium px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
          >
            Projects
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
